/* eslint react/no-multi-comp: 0 */
/* eslint-disable no-console */
import React from 'react';

import PrivateContainer from './AppContainer';
import { UiProvider } from '@app/ui';
import MvcRefreshProvider from './MvcRefreshContext';
import Notifications from '../notifications';
import { useAntdLocale } from '../../utils/antdLocale';

type AppContainerProps = {
    children: React.ReactNode;
};

const AppContainer = ({ children }: AppContainerProps) => {
    const locale = useAntdLocale();

    return (
        <MvcRefreshProvider>
            <UiProvider locale={locale}>
                <PrivateContainer>{children}</PrivateContainer>
                <Notifications />
            </UiProvider>
        </MvcRefreshProvider>
    );
};

export default AppContainer;
